// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-162699f4]{height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;position:fixed}#my-widget *[data-v-162699f4]{font-family:CircularStd;font-weight:400;overscroll-behavior:none}", ""]);
// Exports
module.exports = exports;
